import { render, staticRenderFns } from "./daheCardMeal.vue?vue&type=template&id=9aa1e0f2&"
import script from "./daheCardMeal.vue?vue&type=script&lang=js&"
export * from "./daheCardMeal.vue?vue&type=script&lang=js&"
import style0 from "./daheCardMeal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports